import { createIcon } from './create-icon.js';
export default createIcon('ai', 'IconAi', [["g",{"clip-path":"url(#clip0_1867_155415)"}],["defs",{}]]);